<div class="page-header">
  <h1 class="page-header__title">{{ "materials.title" | translate }}</h1>
  <div class="page-header__actions">
    <a
      claimDirective
      [claims]="[
        {
          claimType: ClaimTypes.Material,
          claimValues: [ClaimValues.Create]
        }
      ]"
      routerLink="/materialen/toevoegen"
      nz-button
      nzType="primary"
    >
      {{ "common.add" | translate }}
      <i class="fa-regular fa-plus"></i>
    </a>
  </div>
</div>

<app-material-overview-table
  [data]="(tableData$ | async)!"
  (delete)="onDeleteConfirm($event)"
  (onChangeQuotation)="onChangeQuotation($event)"
  (onQueryParamsChange)="onQueryParamsChange($event)"
/>
